(function(){
  'use strict';
  var LSM = window.LSM = window.LSM || {};
  LSM.money = function(cents){
    var fmt = (document.documentElement.getAttribute('data-lsm-money') || '\x24{{amount}}');
    var v = (Math.round(cents) / 100);
    var withDec = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v).toString())
      .replace(/\{\{\s*amount\s*\}\}/, withDec);
  };
  function initReveal(root){
    var els = (root || document).querySelectorAll('.lsm-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function(e){ io.observe(e); });
  }
  LSM.initReveal = initReveal;
  LSM.addItems = function(items){
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function(s){ return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function(r){ return r.json().then(function(j){ if (!r.ok || j.status) { throw new Error(j.description || j.message || 'Could not add to cart'); } return j; }); })
      .then(function(j){
        if (drawer && j.sections) {
          drawer.classList.remove('is-empty');
          try { drawer.renderContents(j); } catch(e){ window.location.href = '/cart'; }
        } else if (!drawer) { window.location.href = '/cart'; }
        document.dispatchEvent(new CustomEvent('lsm:cart-added', { detail: j }));
        return j;
      });
  };
  LSM.buyNow = function(items){
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok || j.status) { throw new Error(j.description || 'Could not start checkout'); } window.location.href = '/checkout'; }); });
  };
  function toast(msg){
    var t = document.createElement('div'); t.className = 'lsm-toast'; t.textContent = msg; document.body.appendChild(t);
    setTimeout(function(){ t.classList.add('is-in'); }, 10); setTimeout(function(){ t.classList.remove('is-in'); setTimeout(function(){ t.remove(); }, 400); }, 3200);
  }
  LSM.toast = toast;

  function initProduct(root){
    if (root.__lsm) return; root.__lsm = true;
    var data = JSON.parse(root.querySelector('script[data-lsm-json]').textContent);
    var tiers = data.tiers;
    var state = { variant: data.variants.filter(function(v){ return v.available; })[0] || data.variants[0], qty: 1, pair: false, units: [] };
    var priceEl = root.querySelector('[data-lsm-price]');
    var totalEl = root.querySelector('[data-lsm-total]');
    var saveEl = root.querySelector('[data-lsm-save]');
    var selName = root.querySelector('[data-lsm-selected-name]');
    var unitsBox = root.querySelector('[data-lsm-units]');
    var atc = root.querySelector('[data-lsm-atc]');
    var buy = root.querySelector('[data-lsm-buy]');
    var pairInput = root.querySelector('[data-lsm-pair]');
    function variantById(id){ for (var i=0;i<data.variants.length;i++){ if (String(data.variants[i].id) === String(id)) return data.variants[i]; } return null; }
    function tierFor(q){ var t = tiers[0]; tiers.forEach(function(x){ if (q >= x.q) t = x; }); return t; }
    function render(){
      var v = state.variant;
      if (priceEl) priceEl.textContent = LSM.money(v.price);
      if (selName) selName.textContent = v.label;
      root.querySelectorAll('[data-lsm-variant]').forEach(function(b){ var on = String(b.getAttribute('data-lsm-variant')) === String(v.id); b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      root.querySelectorAll('[data-lsm-tier]').forEach(function(card){
        var q = parseInt(card.getAttribute('data-lsm-tier'), 10); var t = tierFor(q);
        var full = v.price * q; var disc = full - Math.floor(full * t.d / 100);
        var p = card.querySelector('[data-lsm-tier-price]'); if (p) p.textContent = LSM.money(disc);
        var f = card.querySelector('[data-lsm-tier-full]'); if (f) f.textContent = t.d ? LSM.money(full) : '';
        var s = card.querySelector('[data-lsm-tier-save]'); if (s) s.textContent = t.d ? ('You save ' + LSM.money(full - disc)) : 'Standard price';
        card.classList.toggle('is-active', q === state.qty);
        var inp = card.querySelector('input'); if (inp) inp.checked = (q === state.qty);
      });
      if (unitsBox) {
        if (data.variants.length > 1 && state.qty > 1) {
          while (state.units.length < state.qty) state.units.push(v.id);
          state.units.length = state.qty;
          unitsBox.innerHTML = '';
          for (var i = 0; i < state.qty; i++) {
            var row = document.createElement('label'); row.className = 'lsm-unit';
            var sp = document.createElement('span'); sp.textContent = (data.optionName || 'Option') + ' #' + (i + 1); row.appendChild(sp);
            var sel = document.createElement('select'); sel.setAttribute('data-i', i);
            data.variants.forEach(function(x){ var o = document.createElement('option'); o.value = x.id; o.textContent = x.label + (x.available ? '' : ' (sold out)'); o.disabled = !x.available; if (String(x.id) === String(state.units[i])) o.selected = true; sel.appendChild(o); });
            sel.addEventListener('change', function(e){ state.units[parseInt(e.target.getAttribute('data-i'), 10)] = e.target.value; });
            row.appendChild(sel); unitsBox.appendChild(row);
          }
          unitsBox.hidden = false;
        } else { unitsBox.hidden = true; unitsBox.innerHTML = ''; }
      }
      var mainFull = v.price * state.qty;
      var pairPrice = (state.pair && data.pair) ? data.pair.price : 0;
      var itemsCount = state.qty + (state.pair && data.pair ? 1 : 0);
      var t2 = tierFor(itemsCount);
      var full = mainFull + pairPrice;
      var total = full - Math.floor(full * t2.d / 100);
      if (totalEl) totalEl.textContent = LSM.money(total);
      if (saveEl) { saveEl.textContent = t2.d ? (t2.d + '% bundle discount applied automatically in your cart. You save ' + LSM.money(full - total)) : 'Add 2 items for 10% off, 3+ items for 15% off'; saveEl.classList.toggle('is-on', !!t2.d); }
      var ok = v.available;
      [atc, buy].forEach(function(b){ if (b) b.disabled = !ok; });
      if (atc) { var l = atc.querySelector('.lsm-btn__label'); if (l) l.textContent = ok ? (data.atcLabel || 'Add to cart') : 'Sold out'; }
      if (v.image) { var m = root.querySelector('[data-lsm-thumb][data-img="' + v.image + '"]'); var main = root.querySelector('[data-lsm-main-img]'); if (m && main) { main.src = m.getAttribute('data-src'); root.querySelectorAll('[data-lsm-thumb]').forEach(function(x){ x.classList.toggle('is-active', x === m); }); } }
      if (data.variants.length > 1) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
    }
    function items(){
      var list = [];
      if (data.variants.length > 1 && state.qty > 1) {
        var map = {}; var order = [];
        state.units.forEach(function(id){ if (!map[id]) { map[id] = 0; order.push(id); } map[id]++; });
        order.forEach(function(id){ list.push({ id: parseInt(id, 10), quantity: map[id] }); });
      } else { list.push({ id: state.variant.id, quantity: state.qty }); }
      if (state.pair && data.pair) list.push({ id: data.pair.variant, quantity: 1 });
      return list;
    }
    root.addEventListener('click', function(e){
      var vb = e.target.closest('[data-lsm-variant]');
      if (vb) { e.preventDefault(); var nv = variantById(vb.getAttribute('data-lsm-variant')); if (nv) { state.variant = nv; state.units = state.units.map(function(){ return nv.id; }); render(); } return; }
      var tb = e.target.closest('[data-lsm-tier]');
      if (tb) { state.qty = parseInt(tb.getAttribute('data-lsm-tier'), 10); render(); return; }
      var th = e.target.closest('[data-lsm-thumb]');
      if (th) { var main = root.querySelector('[data-lsm-main-img]'); if (main) { main.src = th.getAttribute('data-src'); root.querySelectorAll('[data-lsm-thumb]').forEach(function(x){ x.classList.toggle('is-active', x === th); }); } }
    });
    if (pairInput) pairInput.addEventListener('change', function(){ state.pair = pairInput.checked; var pb = root.querySelector('[data-lsm-pairbox]'); if (pb) pb.classList.toggle('is-active', state.pair); render(); });
    if (atc) atc.addEventListener('click', function(e){ e.preventDefault(); atc.classList.add('is-loading'); LSM.addItems(items()).then(function(){ atc.classList.remove('is-loading'); }).catch(function(err){ atc.classList.remove('is-loading'); toast(err.message); }); });
    if (buy) buy.addEventListener('click', function(e){ e.preventDefault(); buy.classList.add('is-loading'); LSM.buyNow(items()).catch(function(err){ buy.classList.remove('is-loading'); toast(err.message); }); });
    var pre = new URL(window.location.href).searchParams.get('variant'); if (pre && variantById(pre)) state.variant = variantById(pre);
    var sticky = root.querySelector('[data-lsm-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(en){ sticky.classList.toggle('is-in', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(atc);
      sticky.querySelector('button').addEventListener('click', function(){ atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
    render();
  }
  var viewer; var cur = { list: [], i: 0, timer: null };
  function buildViewer(){
    viewer = document.createElement('div'); viewer.className = 'lsm-sv'; viewer.setAttribute('role', 'dialog'); viewer.setAttribute('aria-modal', 'true');
    viewer.innerHTML = '<div class="lsm-sv__inner"><div class="lsm-sv__bars"></div><div class="lsm-sv__head"><span class="lsm-sv__avatar"></span><b class="lsm-sv__title"></b><button class="lsm-sv__close" aria-label="Close">&times;</button></div><div class="lsm-sv__media"></div><button class="lsm-sv__nav lsm-sv__nav--prev" aria-label="Previous story"></button><button class="lsm-sv__nav lsm-sv__nav--next" aria-label="Next story"></button><div class="lsm-sv__foot"><p class="lsm-sv__caption"></p><a class="lsm-btn lsm-btn--primary lsm-btn--shine lsm-btn--block lsm-sv__cta"><span class="lsm-btn__label"></span></a></div></div>';
    document.body.appendChild(viewer);
    viewer.querySelector('.lsm-sv__close').addEventListener('click', closeViewer);
    viewer.querySelector('.lsm-sv__nav--prev').addEventListener('click', function(){ show(cur.i - 1); });
    viewer.querySelector('.lsm-sv__nav--next').addEventListener('click', function(){ show(cur.i + 1); });
    viewer.addEventListener('click', function(e){ if (e.target === viewer) closeViewer(); });
    document.addEventListener('keydown', function(e){ if (!viewer.classList.contains('is-open')) return; if (e.key === 'Escape') closeViewer(); if (e.key === 'ArrowRight') show(cur.i + 1); if (e.key === 'ArrowLeft') show(cur.i - 1); });
  }
  function closeViewer(){ viewer.classList.remove('is-open'); document.documentElement.style.overflow = ''; clearTimeout(cur.timer); var v = viewer.querySelector('video'); if (v) v.pause(); viewer.querySelector('.lsm-sv__media').innerHTML = ''; }
  function show(i){
    if (i < 0) i = 0; if (i >= cur.list.length) { closeViewer(); return; }
    cur.i = i; clearTimeout(cur.timer);
    var s = cur.list[i];
    var bars = viewer.querySelector('.lsm-sv__bars'); bars.innerHTML = '';
    cur.list.forEach(function(_, k){ var b = document.createElement('span'); b.className = 'lsm-sv__bar' + (k < i ? ' is-done' : ''); b.innerHTML = '<i></i>'; bars.appendChild(b); });
    viewer.querySelector('.lsm-sv__title').textContent = s.title || '';
    var av = viewer.querySelector('.lsm-sv__avatar'); av.style.backgroundImage = s.thumb ? 'url(' + s.thumb + ')' : '';
    viewer.querySelector('.lsm-sv__caption').textContent = s.caption || '';
    var cta = viewer.querySelector('.lsm-sv__cta'); cta.href = s.url || '#'; cta.querySelector('.lsm-btn__label').textContent = s.cta || 'Buy now';
    var media = viewer.querySelector('.lsm-sv__media'); media.innerHTML = '';
    var active = bars.children[i].querySelector('i');
    function run(ms){ active.style.transition = 'none'; active.style.width = '0'; requestAnimationFrame(function(){ requestAnimationFrame(function(){ active.style.transition = 'width ' + ms + 'ms linear'; active.style.width = '100%'; }); }); cur.timer = setTimeout(function(){ show(cur.i + 1); }, ms); }
    if (s.video) {
      var v = document.createElement('video'); v.src = s.video; v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.autoplay = true; v.loop = false; if (s.poster) v.poster = s.poster;
      media.appendChild(v);
      v.addEventListener('loadedmetadata', function(){ run(Math.min(15000, Math.max(4000, v.duration * 1000))); });
      v.addEventListener('error', function(){ run(4000); });
      var pr = v.play(); if (pr && pr.catch) pr.catch(function(){});
    } else {
      var img = document.createElement('img'); img.src = s.image; img.alt = s.title || ''; media.appendChild(img); run(5500);
    }
  }
  function openStories(list, i){ if (!viewer) buildViewer(); cur.list = list; viewer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; show(i); }
  LSM.openStories = openStories;
  function initStories(root){
    if (root.__lsm) return; root.__lsm = true;
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-lsm-story]'));
    var list = els.map(function(el){ return JSON.parse(el.getAttribute('data-lsm-story')); });
    els.forEach(function(el, i){ el.addEventListener('click', function(e){ e.preventDefault(); el.classList.add('is-seen'); openStories(list, i); }); });
  }
  function initTrack(root){
    if (root.__lsm) return; root.__lsm = true;
    var f = root.querySelector('form[data-lsm-trackform]');
    if (f) f.addEventListener('submit', function(e){
      e.preventDefault(); var n = (f.querySelector('input').value || '').replace(/\s+/g, '').toUpperCase();
      var out = root.querySelector('[data-lsm-track-out]');
      out.hidden = false;
      if (n.length < 6) { out.className = 'lsm-track__out is-err'; out.textContent = 'Please enter a valid tracking number. You can find it in your shipping confirmation email.'; return; }
      var url = f.getAttribute('data-provider').replace('{n}', encodeURIComponent(n));
      out.className = 'lsm-track__out'; out.innerHTML = '';
      var p = document.createElement('p'); p.textContent = 'Tracking number ' + n + ' - your live tracking results open in a new tab.'; out.appendChild(p);
      var a = document.createElement('a'); a.href = url; a.target = '_blank'; a.rel = 'noopener'; a.className = 'lsm-btn lsm-btn--dark'; a.textContent = 'Open tracking results'; out.appendChild(a);
      window.open(url, '_blank', 'noopener');
    });
  }
  function boot(scope){
    initReveal(scope);
    (scope || document).querySelectorAll('[data-lsm-product]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-lsm-stories]').forEach(initStories);
    (scope || document).querySelectorAll('[data-lsm-track]').forEach(initTrack);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); }); else boot();
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
